$(function() {
    $('.js-slider-blocks .slider__slides').slick({
        infinite: false,
        slidesToShow: 2.78,
        slidesToScroll: 1,
        swipeToSlide: true,
        arrows: true,
        prevArrow: $('.js-slider-blocks .js-arrow-prev'),
        nextArrow: $('.js-slider-blocks .js-arrow-next'),
        responsive: [{
            breakpoint: 767,
            settings: {
                arrows: false,
                slidesToShow: 1.36,
                swipeToSlide: true
            }
        }, ]
    });
});